import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { WrapHeader, WrapPullDown, WrapContent } from './Style'
import { usePulldowns } from 'components/Header/hooks'
import { fieldsTyps } from 'components/Form'
import { pulldowns, testTakerRQ } from 'store/hooks'
import { useLocation } from 'react-router-dom'
import { ContactUsButton } from 'pages/ContactUs'

const Header = () => {
    const { affiliations, groups } = useSelector(state => state.affiliation)
    const { grades, testTakers } = useSelector(state => state.testTaker)
    const { headerFilters } = useSelector(state => state.header)
    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(Boolean);

    const pulldownsData = usePulldowns()

    const setPulldownDefaultValue = pulldowns.useDefaultValue()
    const handleGroup = pulldowns.useHandleGroup()
    const handleGrade = pulldowns.useHandleGrade()
    const cleanTClassess = pulldowns.useCleanTClassess()
    const { refetch: refetchTestTakers } = testTakerRQ.useGetTestTakersOptions()

    // useEffect(() => { setPulldownDefaultValue() }, [testTakers, groups, grades, affiliations, groups])
    useEffect(() => { handleGroup(headerFilters) }, [headerFilters.group])
    useEffect(() => { refetchTestTakers() }, [headerFilters.group, headerFilters.affiliation, headerFilters.grade, headerFilters.t_class])
    useEffect(() => {
        if (headerFilters.affiliation && headerFilters.grade)
            handleGrade(headerFilters)
        else cleanTClassess()
    }, [headerFilters])

    const hideHeaderInFeatures = {
        newsletters: {
            header: true
        },
        tutorials: {
            header: true
        }
    }

    const featureName = pathSegments.length > 0 ? pathSegments[0] : null;
    const hideHeader = hideHeaderInFeatures?.[featureName]?.header || false

    return (
        <WrapHeader>
            {!hideHeader &&
                <WrapContent>
                    {pulldownsData.map((pulldown, index) => {
                        const { name, hide, handleChange } = pulldown
                        const input = {
                            value: headerFilters?.[name],
                            onChange: (value) => handleChange(name, value)
                        }
                        const Component = fieldsTyps[pulldown.component]
                        return (
                            hide ||
                            <WrapPullDown key={index}>
                                <Component input={input} {...pulldown} />
                            </WrapPullDown>
                        )
                    }
                    )}
                </WrapContent>
            }
            <div>
                <ContactUsButton />
            </div>
        </WrapHeader>
    )
}

export default Header